module.exports = __webpack_public_path__ + "static/media/establishedCampsites.5cca812f.svg";